import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=6f280e7b&scoped=true&"
import script from "./Badge.vue?vue&type=script&lang=js&"
export * from "./Badge.vue?vue&type=script&lang=js&"
import style0 from "./Badge.vue?vue&type=style&index=0&id=6f280e7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f280e7b",
  null
  
)

export default component.exports